const sanitizeLocale = (locale: string) => locale.slice(0, 2);

export default sanitizeLocale;
